/**
 * English copy. Same shape as `id.js`.
 *
 * `ELEMENT_PLUS_COPY` is empty here on purpose: the library's own English
 * locale already reads the way we want. Add a key only to re-word one.
 */
export const COPY = {
  app: {
    loading: 'Loading...',
    serverError: 'Something went wrong. Reload the page in a moment.',
  },
  accountForm: {
    retry: 'Try again',
    loadError: 'Could not load the account form',
    targetWarning:
      'Make sure the destination account is correct. A transaction cannot be cancelled after payment.',
    accountWarning:
      'Make sure the account details are correct. A transaction cannot be cancelled after payment.',
    serverNoMatch: 'Server not found',
  },
}

export const ELEMENT_PLUS_COPY = {}
